const HONORIFIC_RE = /^(dr|doctor|mr|mrs|ms|miss|prof|professor)\.?\s+/i;

// Same honorific-stripping approach as components/Avatar.tsx, kept separate
// since that component is specifically the logged-in user's own avatar (it
// pulls profilePictureUrl from UserProvider) - this one is a plain
// yellow-initials badge for rows/cells that only ever have a name to show.
function initialsFor(name: string): string {
    const safeName = name.trim();
    if (!safeName) return '?';
    const stripped = safeName
        .split(/[,\s]+/)
        .filter(Boolean)
        .join(' ')
        .replace(HONORIFIC_RE, '')
        .trim();
    const source = stripped || safeName;
    return source
        .split(/\s+/)
        .filter(Boolean)
        .map((word) => word.charAt(0))
        .join('')
        .toUpperCase()
        .slice(0, 2);
}

interface UserAvatarProps {
    name: string;
    size?: number;
}

export function UserAvatar({ name, size = 36 }: UserAvatarProps) {
    const fontSize = size <= 28 ? 11 : size <= 36 ? 13 : 16;
    return (
        <span
            className="rounded-full bg-yellow-400 text-gray-600 font-bold flex items-center justify-center shrink-0 ring-2 ring-gray-200"
            style={{ width: size, height: size, fontSize }}
        >
            {initialsFor(name)}
        </span>
    );
}
